import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { CommonHelper } from "../../../shared/helpers/CommonHelper";
import { ErrorHandlerProvider } from "../../../shared/providers/errorHandler.provider";
import { ToastsManager } from "ng2-toastr";
import { ActivatedRoute, Router } from '@angular/router';
import { Responsible } from "../../../models/Responsible.model";
import { Component, ElementRef, OnInit } from "@angular/core";
import { LegalCertificateService } from "../../../services/legalCertificate.service";
import { LegalCertificate } from "../../../models/legalCertificate.model";
import * as moment from "moment";
import { AwsService } from "../../../services/aws.service";
import { UserService } from '../../../services/user.service';

@Component({
    selector: "app-legalCertificate-edit",
    templateUrl: "./legalCertificate-edit.component.html",
    styleUrls: ["./legalCertificate-edit.component.scss"]
})
export class LegalCertificateEditComponent implements OnInit {
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    legalCertificateForm: FormGroup;
    responsibles: Responsible[] = new Array<Responsible>();
    fileList;
    selectedFiles: FileList[] = [];
    downloadUrl: string = '';
    types: any;
    renovationDate: string;
    loading: boolean = false;
    certificates: LegalCertificate = new LegalCertificate();

    constructor(
        private formBuilder: FormBuilder,
        public  commonHelper: CommonHelper,
        private errorHandler: ErrorHandlerProvider,
        private awsService:AwsService,
        private legalCertificateService: LegalCertificateService,
        private toastr: ToastsManager,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService
    ){};

    async ngOnInit(): Promise<void> {
        this.loading = true;

        this.legalCertificateForm = this.formBuilder.group({
            name: [null, Validators.required],
            renovationDate: [null, Validators.required],
            notificationsDays: [null, Validators.required],
            type: [null, [this.validateSelectOption]],
            owner: [null, [this.validateSelectOption]],
        });

        this.certificates = await this.legalCertificateService.getById(this.route.snapshot.params['id']);
        this.certificates.renovationDate = moment(this.certificates.renovationDate).format('DD/MM/YYYY')

        this.types = this.commonHelper.getAllCertificateType();

        this.responsibles = await this.userService.getAllUsersAsResponsibles();

        await this.getS3Files();
        if(this.fileList.length > 0)
          this.download(this.fileList[0].Key);

        this.loading = false;

    };

    async download(name){
        this.downloadUrl = await this.awsService.download(name);
    }

    async getS3Files(){
        this.fileList = await this.awsService.getFiles(`legal-certificates/${this.certificates._id}`);
        for (let index = 0; index < 3; index++) {
            const file = await this.awsService.getFiles(`legal-certificates/${this.certificates._id}-${index}`);
            if(file.length){
                this.fileList.push(file[0])
            }
        }
    };

    selectFile(event) {
        this.selectedFiles.push(event.target.files)
    }

    async Edit() {
        try {
            this.certificates.owner.name = this.responsibles.find(x => x._id === this.certificates.owner._id).name;
            this.certificates.renovationDate = moment(this.certificates.renovationDate, 'DD/MM/YYYY').format("YYYY-MM-DD[T00:00:00]")

            let response = await this.legalCertificateService.update(this.certificates);
            if (response._id) {
                this.toastr.success('Certidão / Procuração criado com sucesso!');
                this.router.navigate(['/legalCertificate']);
            } else {
                this.errorHandler.interceptError(response, 'Certidão/Procuração');
            }
        } catch (err) {
            this.errorHandler.interceptError(err, 'Certidão/Procuração');
        }
    }

    cancel() {
        this.router.navigate(['/legal-certificates']);
    }

    verifyValidTouched(fieldName) {
        return !this.legalCertificateForm.get(fieldName).valid && this.legalCertificateForm.get(fieldName).touched;
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0 || control.value == '0' ||
            control.value == undefined || control.value == 'undefined')
            return {type: true};
        return null;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    verifyDate(date){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.certificates.renovationDate = null;
        }
    }

    verifyNameMask(rawValue: string): RegExp[] {
        const mask = /[A-Za-zÁ-Úá-úÀ-Ùà-ùÃ-Õã-õÄ-Üä-üÂ-Ûâ-ûÇç' '0-9]/;
        const strLength = String(rawValue).length;
        const nameMask: RegExp[] = [];
        for (let i = 0; i <= strLength; i++) {
          nameMask.push(mask);
        }
        return nameMask
    }

}



// WEBPACK FOOTER //
// ./src/app/views/legalCertificate/legalCertificate-edit/legalCertificate-edit.component.ts